import { FC, useContext, useMemo } from "react"
import { EcdGenerateReportContext } from "../contexts/EcdGenerateReportContext";
import { Waffles, wafflesKeyColumnName } from "../../../shared/waffles";
import { AdequacyBreakdownDrillInTableData } from "../flyouts/EcdAdequacyBreakdownFlyout";
import { sharedEcdExportDrillInColumnConfig } from "../flyouts/EcdDrillInConfig";
import AdequacyBreakdownTable from "../components/AdequacyBreakdownTable";

const AdequacyBreakdownExport: FC = () => {
  const wizardContext = useContext(EcdGenerateReportContext);
  const title = "Adequacy Breakdown";
  const isEmpty = useMemo(() => {
    const abd = wizardContext.adequacyBreakdownData;
    return (
      abd.overallGapCount == "0" &&
      abd.closedGaps == "0" &&
      abd.newGaps == "0"
    )
  }, [wizardContext.adequacyBreakdownData]);

  const detailData = !isEmpty ? wizardContext.adequacyBreakdownDrillInData.map((row) => {
    return {
      /* eslint-disable sort-keys */
      [wafflesKeyColumnName]: row.customProjectId.toString(),
      projectName: <span>{row.projectName.toString()}</span>,
      newGaps: row.newGaps.toLocaleString(),
      closedGaps: row.closedGaps.toLocaleString(),
      overallGaps: row.overallGapCount.toLocaleString(),
      /* eslint-enable sort-keys */
    }
  }) : [];

  //cut off array when rows will exceed one page in export
  if (detailData.length > 20)
    detailData.length = 20;

  return (
    <div className="ecd-export__wrapper">
      <h2 className="qes-dashboard-tile__title ecd-export__head">{title}</h2>
      <AdequacyBreakdownTable adequacyBreakdownData={wizardContext.adequacyBreakdownData} />
      <br />
      {(wizardContext.addGraphDetails && !isEmpty) && (
        <div className="ecd-export__table">
          <h2 className="qes-dashboard-tile__title ecd-export__head">{title + " Details"}</h2>
          <Waffles<AdequacyBreakdownDrillInTableData>
            columns={sharedEcdExportDrillInColumnConfig}
            data={detailData}
            fullWidth={true}
            loading={detailData.length === 0}
            testId="ecd-export-adequacy-breakdown__table"
            />
        </div>
      )}
    </div>
  )
}

export default AdequacyBreakdownExport;